import KineticHero from '@/components/marketing/KineticHero';
import EditorialMarquee from '@/components/marketing/EditorialMarquee';
import Manifesto from '@/components/marketing/Manifesto';
import ServicesGrid from '@/components/marketing/ServicesGrid';
import BeforeAfter from '@/components/marketing/BeforeAfter';
import ProjectsBento from '@/components/marketing/ProjectsBento';
import TrustBadges from '@/components/marketing/TrustBadges';
import Testimonials from '@/components/marketing/Testimonials';
import CtaBanner from '@/components/marketing/CtaBanner';
import QuoteForm from '@/components/marketing/QuoteForm';

export default function Home() {
  return (
    <>
      <KineticHero />
      <TrustBadges />
      <EditorialMarquee />
      <Manifesto />
      <ServicesGrid compact />
      <BeforeAfter />
      <ProjectsBento compact />
      <Testimonials />
      <CtaBanner place="home" />
      <section id="quote" className="bg-[#FAFAF5] py-28 md:py-40">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#1D4ED8] flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#1D4ED8]" /> Start here
            </div>
            <h2 className="font-display uppercase text-[#0A0A0A] text-4xl md:text-5xl leading-[1.02] tracking-tight">
              Two minutes to a real number.
            </h2>
            <p className="mt-6 text-[#0A0A0A]/70 max-w-md">
              Share a few details and we'll come measure. Every estimate is fixed-price, itemized, and honest about what we don't yet know.
            </p>
          </div>
          <div className="md:col-span-7">
            <QuoteForm source="home-inline" />
          </div>
        </div>
      </section>
    </>
  );
}
